import React from 'react';
import PropTypes from 'prop-types';
import Menu from 'flow/components/ui-components/Menu';
import MenuItem from 'flow/components/ui-components/MenuItem';

import Flow from 'flow';
import Icon from 'flow/components/ui-components/Icon';
import Enum from 'enum';
import Popover from 'flow/components/ui-components/Popover';

export const menuTypes = new Enum(['action', 'explore']);
export const actionMenuActionsProp = PropTypes.arrayOf(
    PropTypes.shape({
        icon: PropTypes.string,
        name: PropTypes.string,
        action: PropTypes.func,
    }),
);

const ActionMenu = ({
    actions,
    menuType,
    anchorComponent,
    mirrorPanel,
    triggerLabel,
}) => {
    const renderMenuItem = (action) => {
        return (
            <MenuItem
                key={action.name}
                className="gap-x-2"
                onClick={() => action.click()}
            >
                {action.icon && (
                    <Icon
                        iconKey={action.icon}
                        className="size-6 text-gray-600"
                    />
                )}
                <span>{action.name}</span>
            </MenuItem>
        );
    };

    const defaultIconComponent = menuTypes.action.is(menuType) ? (
        <Icon iconKey={'add'} size="24px" />
    ) : (
        <Icon iconKey={'more_vert'} size="24px" />
    );

    return (
        <>
            <Popover
                icon={anchorComponent || defaultIconComponent}
                mirrorPanel={mirrorPanel}
                backgroundColor="bg-gray-200 size-10"
                triggerLabel={triggerLabel}
            >
                <Menu id="action-menu-button">
                    <div>{actions.map(renderMenuItem)}</div>
                </Menu>
            </Popover>
        </>
    );
};

ActionMenu.propTypes = {
    actions: actionMenuActionsProp,
    menuType: Flow.PropTypes.inEnum(menuTypes),
    anchorComponent: PropTypes.node,
    useBorderlessIcon: PropTypes.bool,
    mirrorPanel: PropTypes.bool,
    /** Names the icon-only trigger for assistive tech; see Popover. */
    triggerLabel: PropTypes.string,
};

export default React.memo(ActionMenu);
